document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.areas-interactive');
  const mobileBreakpoint = 768;

  sections.forEach(section => {
    // Desktop triggers and content
    const desktopTriggerItems = Array.from(section.querySelectorAll('.areas-interactive__trigger-item'));
    const desktopContentItems = Array.from(section.querySelectorAll('.areas-interactive__desktop-content-item'));
    
    // Mobile triggers and content
    const mobileTriggerItems = Array.from(section.querySelectorAll('.areas-interactive__mobile-trigger-item'));
    const mobileContentItems = Array.from(section.querySelectorAll('.areas-interactive__mobile-content-item'));

    function isMobileView() {
      return window.innerWidth <= mobileBreakpoint;
    }

    // Function to activate a desktop content item
    function activateDesktopItem(targetId) {
      desktopContentItems.forEach(item => {
        const isActive = item.dataset.desktopContentId === targetId;
        item.classList.toggle('active', isActive);
        // Add class if the active item has an image, for specific styling
        if(isActive && item.querySelector('.areas-interactive__desktop-image-wrapper')){
          item.classList.add('has-image-desktop');
        } else {
          item.classList.remove('has-image-desktop');
        }
      });
      desktopTriggerItems.forEach(trigger => {
        trigger.classList.toggle('active', trigger.dataset.triggerId === targetId);
      });
    }

    // Function to activate a mobile content item
    function activateMobileItem(targetId) {
      mobileContentItems.forEach(item => {
        const isActive = item.dataset.mobileContentId === targetId;
        item.classList.toggle('active', isActive);
      });
      mobileTriggerItems.forEach(trigger => {
        trigger.classList.toggle('active', trigger.dataset.mobileTriggerId === targetId);
      });
    }

    // Initial setup
    function initializeSection() {
      if (isMobileView()) {
        // Mobile: Activate first item
        if (mobileTriggerItems.length > 0) {
          activateMobileItem(mobileTriggerItems[0].dataset.mobileTriggerId);
        }
        desktopContentItems.forEach(item => item.classList.remove('active'));
      } else {
        // Desktop: Activate first item
        if (desktopTriggerItems.length > 0) {
          activateDesktopItem(desktopTriggerItems[0].dataset.triggerId);
        }
        mobileContentItems.forEach(item => item.classList.remove('active'));
      }
    }

    // Desktop Event Listeners
    desktopTriggerItems.forEach(trigger => {
      trigger.addEventListener('mouseenter', () => {
        if (!isMobileView()) {
          activateDesktopItem(trigger.dataset.triggerId);
        }
      });

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (!isMobileView()) {
          activateDesktopItem(trigger.dataset.triggerId);
        }
      });
    });

    // Mobile Event Listeners
    mobileTriggerItems.forEach(trigger => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (isMobileView()) {
          activateMobileItem(trigger.dataset.mobileTriggerId);
        }
      });
    });

    // Handle window resize
    let resizeTimeout;
    let wasMobileView = isMobileView();
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const isMobileNow = isMobileView();
        // Only reinitialize if we're switching between mobile and desktop views
        if (wasMobileView !== isMobileNow) {
          wasMobileView = isMobileNow;
          initializeSection();
        }
      }, 250);
    });

    // Call initial setup
    initializeSection();
  });
}); 